import { useEffect, useState } from 'react';

const API = '/api';
const token = () => localStorage.getItem('token');
const ICONOS = ['📄','📋','📊','📈','📉','📦','🔧','⚡','🚗','🏍️','🚛','💡','📚','🔩','🛠️','📐'];

const vacioCategoria = { nombre: '', descripcion: '', icono: '📄', orden: 0 };
const vacioDocumento = { titulo: '', descripcion: '', orden: 0 };

export default function Tecnico() {
  const [categorias, setCategorias] = useState<any[]>([]);
  const [categoriaActiva, setCategoriaActiva] = useState<any>(null);
  const [documentos, setDocumentos] = useState<any[]>([]);
  const [modalCat, setModalCat] = useState(false);
  const [modalDoc, setModalDoc] = useState(false);
  const [editandoCat, setEditandoCat] = useState<any>(null);
  const [editandoDoc, setEditandoDoc] = useState<any>(null);
  const [formCat, setFormCat] = useState<any>(vacioCategoria);
  const [formDoc, setFormDoc] = useState<any>(vacioDocumento);
  const [cargando, setCargando] = useState(false);
  const [subiendoArchivo, setSubiendoArchivo] = useState<number|null>(null);
  const [confirmCat, setConfirmCat] = useState<number|null>(null);
  const [confirmDoc, setConfirmDoc] = useState<number|null>(null);
  const [toast, setToast] = useState('');

  const mostrarToast = (msg: string) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const cargarCategorias = async () => {
    const r = await fetch(`${API}/tecnico/categorias`);
    const data = await r.json();
    setCategorias(data);
    return data;
  };

  const cargarDocumentos = async (catId: number) => {
    const r = await fetch(`${API}/tecnico/categorias/${catId}/documentos`);
    setDocumentos(await r.json());
  };

  useEffect(() => {
    cargarCategorias().then(data => {
      if (data.length > 0) { setCategoriaActiva(data[0]); cargarDocumentos(data[0].id); }
    });
  }, []);

  const seleccionarCategoria = (cat: any) => {
    setCategoriaActiva(cat);
    cargarDocumentos(cat.id);
  };

  // --- Categorías ---
  const abrirNuevaCat = () => { setEditandoCat(null); setFormCat(vacioCategoria); setModalCat(true); };
  const abrirEditarCat = (c: any) => {
    setEditandoCat(c);
    setFormCat({ nombre: c.nombre, descripcion: c.descripcion||'', icono: c.icono||'📄', orden: c.orden||0 });
    setModalCat(true);
  };
  const guardarCat = async () => {
    setCargando(true);
    try {
      const url = editandoCat ? `${API}/tecnico/categorias/${editandoCat.id}` : `${API}/tecnico/categorias`;
      const r = await fetch(url, {
        method: editandoCat ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ ...formCat, orden: Number(formCat.orden) })
      });
      if (!r.ok) throw new Error();
      const cats = await cargarCategorias();
      setModalCat(false);
      mostrarToast(editandoCat ? '✅ Categoría actualizada' : '✅ Categoría creada');
      if (!editandoCat && cats.length > 0) seleccionarCategoria(cats[cats.length - 1]);
    } catch { mostrarToast('❌ Error al guardar'); }
    setCargando(false);
  };
  const eliminarCat = async (id: number) => {
    await fetch(`${API}/tecnico/categorias/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmCat(null);
    const cats = await cargarCategorias();
    if (cats.length > 0) seleccionarCategoria(cats[0]); else { setCategoriaActiva(null); setDocumentos([]); }
    mostrarToast('🗑️ Categoría eliminada');
  };

  // --- Documentos ---
  const abrirNuevoDoc = () => { setEditandoDoc(null); setFormDoc(vacioDocumento); setModalDoc(true); };
  const abrirEditarDoc = (d: any) => {
    setEditandoDoc(d);
    setFormDoc({ titulo: d.titulo, descripcion: d.descripcion||'', orden: d.orden||0 });
    setModalDoc(true);
  };
  const guardarDoc = async () => {
    if (!categoriaActiva) return;
    setCargando(true);
    try {
      const url = editandoDoc ? `${API}/tecnico/documentos/${editandoDoc.id}` : `${API}/tecnico/documentos`;
      const body = editandoDoc
        ? { ...formDoc, orden: Number(formDoc.orden) }
        : { ...formDoc, orden: Number(formDoc.orden), categoria_id: categoriaActiva.id };
      const r = await fetch(url, {
        method: editandoDoc ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify(body)
      });
      if (!r.ok) throw new Error();
      await cargarDocumentos(categoriaActiva.id);
      setModalDoc(false);
      mostrarToast(editandoDoc ? '✅ Documento actualizado' : '✅ Documento creado');
    } catch { mostrarToast('❌ Error al guardar'); }
    setCargando(false);
  };
  const eliminarDoc = async (id: number) => {
    await fetch(`${API}/tecnico/documentos/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmDoc(null);
    if (categoriaActiva) await cargarDocumentos(categoriaActiva.id);
    mostrarToast('🗑️ Documento eliminado');
  };
  const subirArchivo = async (docId: number, file: File) => {
    setSubiendoArchivo(docId);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch(`${API}/tecnico/documentos/${docId}/archivo`, {
        method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd
      });
      if (!r.ok) throw new Error();
      if (categoriaActiva) await cargarDocumentos(categoriaActiva.id);
      mostrarToast('✅ Archivo subido correctamente');
    } catch { mostrarToast('❌ Error al subir archivo'); }
    setSubiendoArchivo(null);
  };

  const iconoTipo = (tipo: string) => {
    if (tipo === 'pdf') return '📕';
    if (['jpg','jpeg','png','webp'].includes(tipo)) return '🖼️';
    if (['doc','docx'].includes(tipo)) return '📘';
    if (['xls','xlsx'].includes(tipo)) return '📗';
    return '📄';
  };

  return (
    <div>
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-white border border-gray-200 shadow-xl rounded-xl px-5 py-3 text-sm font-semibold text-gray-700">{toast}</div>
      )}

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-azul">Módulo Técnico</h1>
          <p className="text-gray-500 text-sm mt-1">Categorías y documentos técnicos para el sitio público</p>
        </div>
        <button onClick={abrirNuevaCat}
          className="bg-azul hover:bg-azul-dark text-white px-5 py-2.5 rounded-xl font-semibold text-sm transition-all">
          + Nueva Categoría
        </button>
      </div>

      <div className="flex gap-6">
        {/* Panel izquierdo — Categorías */}
        <div className="w-64 flex-shrink-0">
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Categorías</span>
            </div>
            {categorias.length === 0 ? (
              <div className="p-6 text-center text-gray-400 text-sm">Sin categorías</div>
            ) : (
              <div className="p-2 space-y-1">
                {categorias.map(cat => (
                  <div key={cat.id}
                    onClick={() => seleccionarCategoria(cat)}
                    className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all group ${
                      categoriaActiva?.id === cat.id ? 'bg-azul text-white' : 'hover:bg-gray-50 text-gray-700'
                    }`}>
                    <div className="flex items-center gap-2 min-w-0">
                      <span>{cat.icono}</span>
                      <span className="text-sm font-medium truncate">{cat.nombre}</span>
                    </div>
                    <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-all flex-shrink-0 ml-1">
                      <button onClick={e => { e.stopPropagation(); abrirEditarCat(cat); }}
                        className={`text-xs px-1.5 py-0.5 rounded ${categoriaActiva?.id === cat.id ? 'hover:bg-white/20' : 'hover:bg-gray-200'}`}>✏️</button>
                      <button onClick={e => { e.stopPropagation(); setConfirmCat(cat.id); }}
                        className={`text-xs px-1.5 py-0.5 rounded ${categoriaActiva?.id === cat.id ? 'hover:bg-white/20' : 'hover:bg-gray-200'}`}>🗑️</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Panel derecho — Documentos */}
        <div className="flex-1">
          {!categoriaActiva ? (
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm flex items-center justify-center h-64">
              <div className="text-center text-gray-400">
                <div className="text-4xl mb-3">📂</div>
                <div className="font-medium">Creá una categoría para comenzar</div>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center">
                <div>
                  <div className="font-bold text-gray-800">{categoriaActiva.icono} {categoriaActiva.nombre}</div>
                  {categoriaActiva.descripcion && <div className="text-xs text-gray-400 mt-0.5">{categoriaActiva.descripcion}</div>}
                </div>
                <button onClick={abrirNuevoDoc}
                  className="bg-rojo hover:bg-rojo-dark text-white px-4 py-2 rounded-xl font-semibold text-sm transition-all">
                  + Agregar Documento
                </button>
              </div>

              {documentos.length === 0 ? (
                <div className="text-center py-16 text-gray-400">
                  <div className="text-4xl mb-3">📄</div>
                  <div className="font-medium">Sin documentos en esta categoría</div>
                  <div className="text-sm mt-1">Agregá el primero con el botón de arriba</div>
                </div>
              ) : (
                <div className="divide-y divide-gray-50">
                  {documentos.map(doc => (
                    <div key={doc.id} className="px-6 py-4 flex items-center gap-4 hover:bg-gray-50/50 transition-colors">
                      <div className="text-2xl">{doc.archivo_url ? iconoTipo(doc.tipo) : '📄'}</div>
                      <div className="flex-1 min-w-0">
                        <div className="font-semibold text-gray-800">{doc.titulo}</div>
                        {doc.descripcion && <div className="text-xs text-gray-400 mt-0.5">{doc.descripcion}</div>}
                        {doc.archivo_url && (
                          <a href={`https://ticobaterias.com${doc.archivo_url}`} target="_blank" rel="noreferrer"
                            className="text-xs text-azul hover:underline mt-1 inline-block">
                            Ver archivo ↗
                          </a>
                        )}
                      </div>
                      <div className="flex items-center gap-2 flex-shrink-0">
                        {/* Subir archivo */}
                        <label className={`cursor-pointer text-xs font-medium px-3 py-1.5 rounded-lg transition-all ${
                          doc.archivo_url ? 'bg-green-50 text-green-600 hover:bg-green-100' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                        }`}>
                          {subiendoArchivo === doc.id ? '⏳ Subiendo...' : doc.archivo_url ? '📎 Cambiar' : '📎 Subir'}
                          <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.webp" className="hidden"
                            onChange={e => e.target.files && subirArchivo(doc.id, e.target.files[0])} />
                        </label>
                        <button onClick={() => abrirEditarDoc(doc)}
                          className="text-azul hover:text-azul-dark font-medium text-sm transition-colors">Editar</button>
                        <button onClick={() => setConfirmDoc(doc.id)}
                          className="text-rojo hover:text-rojo-dark font-medium text-sm transition-colors">Eliminar</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modal Categoría */}
      {modalCat && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-lg font-bold text-azul">{editandoCat ? 'Editar Categoría' : 'Nueva Categoría'}</h2>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Nombre *</label>
                <input value={formCat.nombre} onChange={e => setFormCat({...formCat, nombre: e.target.value})}
                  placeholder="Ej: Fichas Técnicas Autos"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-2">Ícono</label>
                <div className="flex flex-wrap gap-2">
                  {ICONOS.map(ic => (
                    <button key={ic} onClick={() => setFormCat({...formCat, icono: ic})}
                      className={`w-10 h-10 rounded-lg text-xl transition-all ${formCat.icono === ic ? 'bg-azul ring-2 ring-azul' : 'bg-gray-100 hover:bg-gray-200'}`}>
                      {ic}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Descripción</label>
                <input value={formCat.descripcion} onChange={e => setFormCat({...formCat, descripcion: e.target.value})}
                  placeholder="Descripción opcional"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Orden</label>
                <input value={formCat.orden} onChange={e => setFormCat({...formCat, orden: e.target.value})}
                  type="number" min="0"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setModalCat(false)}
                className="px-5 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={guardarCat} disabled={cargando || !formCat.nombre}
                className="px-5 py-2.5 rounded-xl bg-azul hover:bg-azul-dark text-white text-sm font-semibold disabled:opacity-50">
                {cargando ? 'Guardando...' : editandoCat ? 'Guardar Cambios' : 'Crear Categoría'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Documento */}
      {modalDoc && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-lg font-bold text-azul">{editandoDoc ? 'Editar Documento' : 'Nuevo Documento'}</h2>
              <p className="text-xs text-gray-400 mt-1">Categoría: {categoriaActiva?.icono} {categoriaActiva?.nombre}</p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Título *</label>
                <input value={formDoc.titulo} onChange={e => setFormDoc({...formDoc, titulo: e.target.value})}
                  placeholder="Ej: Ficha técnica batería AGM"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Descripción</label>
                <textarea value={formDoc.descripcion} onChange={e => setFormDoc({...formDoc, descripcion: e.target.value})}
                  placeholder="Descripción opcional..." rows={3}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul resize-none" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Orden</label>
                <input value={formDoc.orden} onChange={e => setFormDoc({...formDoc, orden: e.target.value})}
                  type="number" min="0"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              {!editandoDoc && (
                <div className="bg-blue-50 rounded-xl p-3 text-xs text-blue-600">
                  💡 Después de crear el documento podés subir el archivo PDF desde la tabla
                </div>
              )}
            </div>
            <div className="p-6 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setModalDoc(false)}
                className="px-5 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={guardarDoc} disabled={cargando || !formDoc.titulo}
                className="px-5 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold disabled:opacity-50">
                {cargando ? 'Guardando...' : editandoDoc ? 'Guardar Cambios' : 'Crear Documento'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Confirmar eliminar categoría */}
      {confirmCat !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar categoría?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Se eliminarán también todos sus documentos.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmCat(null)}
                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => eliminarCat(confirmCat)}
                className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Confirmar eliminar documento */}
      {confirmDoc !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar documento?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Esta acción no se puede deshacer.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmDoc(null)}
                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => eliminarDoc(confirmDoc)}
                className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
